const LAST_SUBMITTED_EMAIL_CACHE_KEY = 'lastSubmittedEmail';

export const getLastSubmittedEmail = () =>
  localStorage.getItem(LAST_SUBMITTED_EMAIL_CACHE_KEY);

export const storeLastSubmittedEmail = (email) =>
  localStorage.setItem(LAST_SUBMITTED_EMAIL_CACHE_KEY, email);
